import { render, staticRenderFns } from "./LexiconDetails.vue?vue&type=template&id=93f056ec&scoped=true"
import script from "./LexiconDetails.vue?vue&type=script&lang=js"
export * from "./LexiconDetails.vue?vue&type=script&lang=js"
import style0 from "./LexiconDetails.vue?vue&type=style&index=0&id=93f056ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f056ec",
  null
  
)

export default component.exports